import React, { useState } from 'react';

interface AddToCartProps {
  productId: string;
  cartId: string;
  className?: string;
  buttonText?: string;
}

export const AddToCart: React.FC<AddToCartProps> = ({
  productId,
  className = "",
  buttonText = "Add to Cart",
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleAddToCart = async () => {
    if (!productId) {
      setError("Product ID is required");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`/cart/add/${productId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
      });

      if (!response.ok && response.status !== 423) {
        throw new Error(`Failed to add product to cart: ${response.status}`);
      } else if (response.status === 423) {
        // Cart is locked - show alert and redirect to cart page
        alert("Otključajte košaricu da biste dodali više proizvoda");
        window.location.href = "/cart";
        return;
      }

      // Redirect to cart page on success
      window.location.href = "/cart";
    } catch (err) {
      console.error("Error adding product to cart:", err);
      setError(
        err instanceof Error ? err.message : "Failed to add product to cart"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="product--teaser__content-add-to-cart">
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleAddToCart();
        }}
        disabled={isLoading}
        className={`btn-cart add-to-cart-button-new ${className}`}
      >
        {isLoading ? (
          <span className="flex items-center">
            <svg
              className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
            Molim pričekajte...
          </span>
        ) : (
          buttonText
        )}
      </button>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
};
